/**
 * The questions on the home page, in order. The answers live in the locale
 * files (`home.faq.items.<key>`); the build reuses them for crawlers and the
 * FAQ structured data, so the page and its metadata always say the same.
 */
export const FAQ_KEYS = ['upload', 'faces', 'plates', 'cuts', 'captions', 'phone', 'free'] as const;
export type FaqKey = (typeof FAQ_KEYS)[number];
